import { useState } from 'react';

const FAQS = [
  {
    q: 'Are ChatGPT ads available right now?',
    a: "OpenAI announced testing plans for ads in ChatGPT for eligible Free and Go adult users in the U.S.; paid tiers remain ad-free. Availability depends on rollout timing and testing expansion. We prepare your brand so you're ready and competitive as placements expand across AI platforms.",
  },
  {
    q: 'Can you guarantee we show up in ChatGPT answers?',
    a: "No one can guarantee placement inside a model's answers — and anyone who does is selling you something. What we can do is maximize your odds: structure your content, schema, and authority signals the way generative engines reward, then track your visibility over time so you can see it improving.",
  },
  {
    q: 'What is GEO and how is it different from SEO?',
    a: 'SEO optimizes to rank a link on a results page. GEO — Generative Engine Optimization — optimizes so your business is named inside the AI\'s written answer. It blends content, schema, and authority signals so engines like ChatGPT and Perplexity cite you when they respond to a customer\'s question.',
  },
  {
    q: 'How quickly can AI voice agents be set up?',
    a: "Most Voice AI agents go live within days, not weeks. We train it on your services, scripts, and escalation rules, wire it to your calendar and CRM, and test it before launch so it's answering and booking from day one.",
  },
  {
    q: 'Do I need all three pillars or can I start with one?',
    a: 'Start with one. Most clients begin where the leak is biggest — often Voice AI to stop missing calls, or GEO to get found in AI search. We sequence the other pillars in as the first one proves its ROI.',
  },
  {
    q: 'What kind of results should I expect?',
    a: 'Results depend on your starting point, market, and budget — but the levers are the same: more AI visibility, faster lead response, and fewer leaks in your funnel. Your free AI check projects the specific upside for your business before you commit to anything.',
  },
  {
    q: 'How do you measure AI visibility?',
    a: 'We run real prompts across ChatGPT, Perplexity, and other assistants — the kinds of questions your customers actually ask — and track whether and how your business gets mentioned. That gives you a visibility score you can watch move over time.',
  },
  {
    q: 'Is this only for large businesses?',
    a: "No — it's built for local Florida operators. Home-service contractors, practices, and small professional firms benefit most, because AI search and fast lead response level the playing field against bigger competitors.",
  },
  {
    q: 'What if AI platforms change their policies?',
    a: "They will — this space moves fast. That's exactly why we stay close to it, adjust your strategy as formats and rules evolve, and keep your brand positioned to capitalize on new placements as they roll out.",
  },
  {
    q: 'Do you work with businesses outside Florida?',
    a: "We're Florida-focused by design — it's how we know your markets, seasons, and buyers so well. If you're outside Florida, reach out and we'll tell you honestly whether we're the right fit.",
  },
  {
    q: 'How is pricing structured?',
    a: "Pricing depends on which pillars you start with and the size of your market. We keep it transparent — you'll see exactly what you're paying for and what it's expected to return. The free AI check is where we scope it.",
  },
  {
    q: "What's included in the free Assessment?",
    a: "Your free AI check covers five things: an AI Visibility Score, a competitive analysis, a GEO gap analysis, a lead funnel review, and a Voice AI ROI projection — so you know what's broken and what to fix first before spending a dollar.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section
      id="faq"
      className="relative py-28 overflow-hidden bg-gradient-to-b from-white via-teal-50/40 to-white"
    >
      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <div className="eyebrow reveal">Frequently Asked Questions</div>
          <h2 className="mt-5 h-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] reveal">
            Everything Worth Asking.
          </h2>
          <p className="mt-6 text-slate-600 font-body font-light text-base md:text-lg reveal">
            Everything you need to know about AI marketing for Florida businesses.
          </p>
        </div>

        <div className="space-y-4">
          {FAQS.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div key={index} className="glass rounded-2xl px-6 py-5 reveal">
                <button
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="w-full flex items-center justify-between gap-4 text-left cursor-pointer"
                >
                  <span className="h-display text-xl md:text-2xl leading-tight">{faq.q}</span>
                  <i
                    className={`faq-chev ri-arrow-down-s-line text-teal-500 text-2xl shrink-0 ${
                      open ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                {open && (
                  <p className="mt-4 text-slate-600 font-body font-light text-sm md:text-base leading-relaxed">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
